import React from "react";
import Link from "gatsby-link";
import Helmet from "react-helmet";

import Publication from "../components/publication";
import Videoframe from "../components/videoframe";
import ExtLink from "../components/ext-link";

import headerImg from "./img/arbridgebuilder.jpg";
const paperURL =
  "http://digital.liby.waikato.ac.nz/conferences/ivcnz07/papers/ivcnz07-paper36.pdf";
import slidesPDF from "./download/2007_petzold+pfeil+riechert_ar-bridge-builder_talk-slides.pdf";

const abstractBibTexStr = `@inproceedings{Petzold2007,
  author = {Petzold, Frank and Pfeil, Jonas and Riechert, Christian and Green, Richard},
  title = {AR Bridge Builder: Real-Time Vectorisation of Freehand Sketched Structures for an AR Application},
  booktitle = {Image and Vision Computing New Zealand 2007},
  year = {2007},
  location = {Hamilton, New Zealand},
  pages = {192--197},
}`;

export default () => (
  <div>
    <Helmet>
      <title>AR Bridge Builder</title>
      <meta
        name="description"
        content="AR Bridge Builder is an augmented reality version of the game Bridge Builder where the goal is to get a train safely across a river or valley."
      />
    </Helmet>
    <h1>AR Bridge Builder</h1>
    <Videoframe
      youtubeId="k6Ldio17YFA"
      img={headerImg}
      imgAltText="AR Bridge Builder Project: Laptop, webcam and whiteboard"
    />

    <div id="description">
      <p>
        This was a student project I worked on together with two fellow students
        while studying at the University of Canterbury, New Zealand. Published
        as a paper at the IVCNZ07 and received the{" "}
        <strong>award for the best oral student presentation</strong>.
      </p>

      <Publication
        type="Paper"
        title="AR Bridge Builder: Real-time Vectorisation of Freehand Sketched Structures for an AR Application"
        bookTitle="Proceedings of Image and Vision Computing New Zealand 2007"
        authors="Frank Petzold, Jonas Pfeil, Christian Riechert and Richard Green"
        bibTex={abstractBibTexStr}
        paperURL={paperURL}
        paperLinkText="Paper"
        talkSlidesURL={slidesPDF}
        talkSlidesLinkText="Talk Slides"
      />

      <h2>Abstract</h2>
      <p>
        AR Bridge Builder is an augmented reality version of the game Bridge
        Builder where the goal is to get a train safely across a river or
        valley.
      </p>
      <p>
        The bridge is drawn on a whiteboard (blue for trusses and red for anchor
        points). Our computer vision algorithm recognizes the bridge and tracks
        it over time. The resulting model is simulated using PhysX and overlaid
        over the camera image on the laptop monitor. Tension and pressure on the
        trusses are visualized using shades of blue and red, respectively.
      </p>
      <p>
        When starting the game the user has to point the camera straight at the
        whiteboard which initializes a reference coordinate system where we
        assume the image plane is parallel to the whiteboard. After that the
        user can move the camera and the simulated bridge is drawn perspectively
        correct. This works because all the points of the bridge lie on a flat
        surface, enabling us to compute a{" "}
        <ExtLink to="http://en.wikipedia.org/wiki/Homography">
          homography
        </ExtLink>.
      </p>
    </div>
    <div id="facts">
      <dl>
        <dt>Software</dt>
        <dd>C++, OpenCV, PhysX</dd>
        <dt>People</dt>
        <dd>Frank Petzold</dd>
        <dd>Jonas Pfeil</dd>
        <dd>Christian Riechert</dd>
        <dt>Advisors</dt>
        <dd>
          <ExtLink to="https://people.unisa.edu.au/Mark.Billinghurst">
            Prof. M. Billinghurst
          </ExtLink>
        </dd>
        <dd>Dr. R. Green</dd>
        <dt>Year</dt>
        <dd>2007</dd>
      </dl>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/arbridgebuilder.jsx